import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import {FormsModule} from '@angular/forms';
import {HttpModule} from '../services/http.module';
import {NgZorroAntdMobileModule, InputItemComponent} from 'ng-zorro-antd-mobile';
import {NgxEchartsModule} from 'ngx-echarts';

import {HeaderComponent} from './header/header.component';
import {StatusComponent} from './status/status.component';
import {AirportListComponent} from './airport-list/airport-list.component';
import {StatisticsOfDaysAbroadComponent} from './statistics-of-days-abroad/statistics-of-days-abroad.component';
import {DatePickerComponent} from './date-picker/date-picker.component';
import {NetworkStatusComponent} from './network-status/network-status.component';

import {TranslateModule} from '@ngx-translate/core';
import { FormItemComponent } from './form-item/form-item.component';

@NgModule({
    declarations: [
        HeaderComponent,
        StatusComponent,
        AirportListComponent,
        StatisticsOfDaysAbroadComponent,
        DatePickerComponent,
        NetworkStatusComponent,
        FormItemComponent
    ],
    imports: [
        IonicModule,
        FormsModule,
        HttpModule,
        NgZorroAntdMobileModule,
        CommonModule,
        TranslateModule,
        NgxEchartsModule
    ],
    exports: [
        HeaderComponent,
        StatusComponent,
        AirportListComponent,
        StatisticsOfDaysAbroadComponent,
        DatePickerComponent,
        NetworkStatusComponent,
        FormItemComponent
    ]
})
export class ComponentsModule {}
